import { match } from 'ts-pattern';

export const CurrencySymbol = ({
  currency = 'EUR',
}: {
  currency?: 'GBP' | 'USD' | 'CAD' | 'EUR' | string;
}) =>
  match(currency)
    .with('GBP', () => <span>£</span>)
    .with('USD', () => <span>$</span>)
    .with('CAD', () => <span>$</span>)
    .with('EUR', () => <span>{`\u20ac`}</span>)
    .otherwise(() => <span>{currency}</span>);
